var $ = require('jquery');

var filters = function (opts) {
    // Options:
    //
    //   filtersSelector -- Selector for the filters' parent element
    //   tableSelector   -- Selector for the statistics table
    //   makeUrl(s, t)   -- Return an URL for season and tournament.
    //                      Tournament may be null.
    //   sortField       -- Name of the sort field, default: 'sort'
    var filters, table, form, season, tournament, sort, player_stats,
        sortField = opts.sortField || 'sort';


    var formChanged = function (e) {
        if (e.target.name != 'season' && e.target.name != 'tournament') {
            form.submit();
        }
    };

    var seasonChanged = function () {
        params = window.location.href.split('?')[1] || '';
        if (params) params = '?' + params;
        window.location = opts.makeUrl(season.val(), tournament.val()) + params;
    };

    var tournamentChanged = function () {
        params = window.location.href.split('?')[1] || '';
        if (params) params = '?' + params;
        window.location = opts.makeUrl(season.val(), tournament.val()) + params;
    };

    $(function () {
        filters = $(opts.filtersSelector);
        table = $(opts.tableSelector);
        form = filters.find('form').on('change', formChanged);
        season = filters.find('[name=season]').change(seasonChanged);
        tournament = filters.find('[name=tournament]')
            .change(tournamentChanged);

        sort = filters.find('[name=' + sortField + ']');
        player_stats = filters.find('[name=player_stats]');
        table.on('click', '[data-sort-field]', function (e) {
            e.preventDefault();
            sort.val($(this).data('sort-field'));
            form.submit();
        });
    });
};
readActLang = function(name){
    var cookies = document.cookie.split(';')
    for(var i = 0; i<cookies.length; i++){
        if(cookies[i].includes && cookies[i].includes(name)){
            return cookies[i].split("=")[1]
        }
    }
}

module.exports = {
    filters: filters,
    readActLang: readActLang
};



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/stats/js/stats.js
// module id = 4
// module chunks = 0